import { MessageCircle } from "lucide-react";

export const WhatsAppButton = () => {
  const whatsappNumber = "33781477380";
  const message = encodeURIComponent(
    "Bonjour, je souhaite prendre rendez-vous pour une consultation optique."
  );

  return (
    <a
      href={`https://wa.me/${whatsappNumber}?text=${message}`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-button"
      className="whatsapp-float"
      aria-label="Nous contacter sur WhatsApp"
    >
      <MessageCircle size={28} strokeWidth={1.5} />
    </a>
  );
};
